import * as React from 'react';
import { Alert } from 'reactstrap';
import { TextInputField } from '../../../components/Forms/fields';
import { PrescriptionsSettingsData } from '../../../models';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { SettingsItemContentProps } from '../SettingsItem';

interface PrescriptionsSettingsProps extends SettingsItemContentProps {
    values: PrescriptionsSettingsData;
    onChange: (settings: PrescriptionsSettingsData) => void;
}

const PrescriptionsSettings: React.FC<PrescriptionsSettingsProps> = ({ values, onChange }) => {
    const t = useTranslations();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-S)' }}>
            <Alert color="secondary" isOpen>
                {t(TK.prescriptionsSettingsDescription)}
            </Alert>

            <TextInputField
                id="prescriptions-local-prescricao-codigo"
                label={t(TK.prescriptionSpmsLocalPrescricaoCodigo)}
                helpText={t(TK.prescriptionSpmsLocalPrescricaoCodigoHelp)}
                value={values?.spmsLocalPrescricaoCodigo || ''}
                onChange={spmsLocalPrescricaoCodigo => onChange({ ...values, spmsLocalPrescricaoCodigo })}
            />

            <TextInputField
                id="prescriptions-subsistema-entidade-codigo"
                label={t(TK.prescriptionSpmsSubsistemaEntidadeCodigo)}
                helpText={t(TK.prescriptionSpmsSubsistemaEntidadeCodigoHelp)}
                value={values?.spmsSubsistemaEntidadeCodigo || ''}
                onChange={spmsSubsistemaEntidadeCodigo => onChange({ ...values, spmsSubsistemaEntidadeCodigo })}
            />

            <TextInputField
                id="prescriptions-subsistema-entidade-dominio"
                label={t(TK.prescriptionSpmsSubsistemaEntidadeDominio)}
                helpText={t(TK.prescriptionSpmsSubsistemaEntidadeDominioHelp)}
                value={values?.spmsSubsistemaEntidadeDominio || ''}
                onChange={spmsSubsistemaEntidadeDominio => onChange({ ...values, spmsSubsistemaEntidadeDominio })}
            />

            <TextInputField
                id="prescriptions-subsistema-entidade-pais"
                label={t(TK.prescriptionSpmsSubsistemaEntidadePais)}
                helpText={t(TK.prescriptionSpmsSubsistemaEntidadePaisHelp)}
                value={values?.spmsSubsistemaEntidadePais || 'PT'}
                onChange={spmsSubsistemaEntidadePais => onChange({ ...values, spmsSubsistemaEntidadePais })}
            />
        </div>
    );
};

export default PrescriptionsSettings;
